export var HideStrategy;
(function (HideStrategy) {
    HideStrategy["EXPECTED_WAITING_TIME"] = "expected_waiting_time";
    HideStrategy["ALL_AGENTS_AWAY"] = "all_agents_away";
    HideStrategy["ALL_AGENTS_OFFLINE"] = "all_agents_offline";
    HideStrategy["NEVER"] = "never";
})(HideStrategy || (HideStrategy = {}));
